module.exports = __webpack_public_path__ + "static/media/golden.a4ca2ac7.png";